import SvgLogoSmall from '@img/icons/logo-small.svg';
import * as React from 'react';
import S from './SectionLinks.styles';
const SectionLinks = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, props.title),
        React.createElement(S.List, null, props.items.map((item) => (React.createElement(S.Item, { key: item.text },
            React.createElement(S.Link, { href: item.url, target: item.target ?? '_self' },
                React.createElement(SvgLogoSmall, null),
                " ",
                item.text)))))));
};
export default SectionLinks;
